import React, { Component } from 'react'
import { Container, Row, Col, Button } from 'reactstrap';
import {
  isMobile, MobileOnlyView, isBrowser
} from "react-device-detect";
import { Link } from "react-router-dom";
import { FaEnvelope, FaFacebookSquare, FaGoogle, FaInstagram, FaPhone, FaUser, FaYoutube } from 'react-icons/fa';
import { FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi';
import Catlist from './Catlist';

const styles = {
  backgroundImage: 'linear-gradient(15deg, #fff, #fefefefe)',
  paddingTop: '50px',
  color: '#000',
  textAlign: 'left',
  zIndex: 998,
  position: 'relative'
}

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiList: [],
      categoryImages: []
    }
  }

  componentDidMount() {


  }
  render() {

    return (

      <div style={styles}>
        <Container className="d-print-none">
          <Row>
            <Col md={7}>
              <Row>
                <Col md={3} xs={3} className="d-flex flex-column text-center "><img src={'/images/foo-1.png'} style={{ width: '100%', padding: isMobile ? "0.6rem 0.1rem" : '2rem' }} /><h5 style={{ fontSize: isMobile ? '0.7rem' : "" }}> RETURN POLICY</h5>  </Col>
                <Col md={3} xs={3} className="d-flex flex-column text-center "><img src={'/images/foo-2.png'} style={{ width: '100%', padding: isMobile ? "0.6rem 0.1rem" : '2rem' }} /><h5 style={{ fontSize: isMobile ? '0.7rem' : "" }}> CUSTOMER SUPPORT</h5>  </Col>
                <Col md={3} xs={3} className="d-flex flex-column text-center "><img src={'/images/foo-3.png'} style={{ width: '100%', padding: isMobile ? "0.6rem 0.1rem" : '2rem' }} /><h5 style={{ fontSize: isMobile ? '0.7rem' : "" }}> FREE SHIPPING*</h5>  </Col>
                <Col md={3} xs={3} className="d-flex flex-column text-center "><img src={'/images/foo-4.png'} style={{ width: '100%', padding: isMobile ? "0.6rem 0.1rem" : '2rem' }} /><h5 style={{ fontSize: isMobile ? '0.7rem' : "" }}> SECURE PAYMENT</h5>  </Col>
              </Row>
            </Col>
            <Col className={isMobile ? "mt-5" : ""} md={5}>
              <Row>
                <Col xs={6} className="d-flex align-items-center justify-content-right"><Link to={'/track-order'} className="black-o-btn p-2 ">Track Order</Link>  </Col>
                <Col xs={6}><img src={'/images/rom-tra.png'} style={{ width: '100%' }} /> </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-5 mt-md-3">

            <Col md={6}>
              <Catlist />
            </Col>
            <Col md={3} className={isMobile ? "" : "text-right"}>
              <h4 className="my-5 my-md-3">ABOUT US</h4>
              <Link to={`/about/payment-options`}><p style={{ color: '#000' }}> PAYMENT OPTIONS </p></Link>
              <Link to={`/about/`}><p style={{ color: '#000' }}> ABOUT US   </p></Link>
              <Link to={`/locator`}><p style={{ color: '#000' }}> STORE LOCATOR </p></Link>
              <Link to={`/about/customer-support`}><p style={{ color: '#000' }}> CUSTOMER SUPPORT  </p></Link>
              <Link to={`/contact`}><p style={{ color: '#000' }}> CONTACT US   </p></Link>
              <small>{isMobile && <img src="/images/india.jpg" loading="lazy" width="30" style={{ borderRadius: '4px', marginRight: '10px' }} />}
      PROUDLY MADE IN INDIA</small>
            </Col>
            <Col md={3} className={isMobile ? "" : "text-right"}>
              <h4 className="my-5 my-md-3"> POLICIES</h4>
              <Link to={`/about/returns`}><p style={{ color: '#000' }}>RETURNS & EXCHANGE POLICY   </p></Link>      
              <Link to={`/about/terms`}><p style={{ color: '#000' }}>TERMS & CONDITIONS OF USE </p></Link>
              <Link to={`/about/terms`}><p style={{ color: '#000' }}>PROMOTIONAL T&C  </p></Link>
              <Link to={`about/privacy-policy`}><p style={{ color: '#000' }}>PRIVACY POLICY   </p></Link>
              {!isMobile && <div className="text-left"><img src="/images/india.jpg" loading="lazy" width="30" style={{ borderRadius: '4px' }} /></div>}

            </Col>
          </Row>
          <Row className="mt-md-5">
            <Col md={6}>
              <Row>
                <Col md='12' className="text-left"><b><small>All rights reserved © {new Date().getFullYear()}</small></b></Col>
              </Row>
              <Row>
                <Col md='12' ><h5>Romantic Unisex Lingerie Store </h5></Col>
              </Row>
            </Col>
            <Col md={6} className={isMobile ? "text-center my-3" : "text-right my-3"}>
              <a href={`https://www.facebook.com/136796286437306/posts/2436134869836758/`} className="mx-1"> <FaFacebookSquare size={35} style={{ color: 'grey' }} /> </a>              
              <a href={`https://maps.app.goo.gl/Q1GkWvLX5KHy9mji7`} className="mx-1"> <FaGoogle size={35} style={{ color: 'grey' }} /> </a>
              <a href={`https://instagram.com/romantic_mangalore`} className="mx-1"> <FiInstagram size={35} style={{ color: 'grey' }} /> </a>
            </Col>
          </Row>
        </Container>
        <div className="d-print-none" style={{ background: '#000', color: "#fff", textAlign: 'center', padding: '3px', width: '100%', fontSize:'13px' }}>
          <span className="mr-3"> Developed with ♥ by <a style={{ color: '#fff' }} href="https://tikanga.in" target="_blank">Tikanga.in </a></span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js